<template>
    <div class="question-item">

        <div id="treeWrapper">
        </div>

        <div id="overlay" class="close-node-popup">
            <div id="box" class="modal-box">
                <span  @click="hideNodePopup()" class="float-right"><v-icon class="font-weight-light">clear</v-icon></span>
                <div id="box-content">
                </div>
            </div>
        </div>

        <div id="overlayColumns" class="close-node-popup">
            <div id="boxColumns" class="modal-box">
                <span  @click="hideNodePopup()" class="float-right"><v-icon class="font-weight-light">clear</v-icon></span>
                <div style="width: 100%; height: 100%;">
                    <div id="box-content-one" style="width:50%; float:left">
                    </div>
                    <div id="box-content-two" style="width:50%; float:right">
                    </div>
                </div>
            </div>
        </div>

        <div id="overlayLabel" class="close-node-popup">
            <div id="boxLabel" class="modal-box">
                <div class="close-edit-label">
                    <span>Edit label</span>
                    <span  @click="hideEditLabelPopup()" class="float-right"><v-icon class="font-weight-light">clear</v-icon></span>
                </div>
                <div id="box-content-label">
                    <v-text-field
                        v-model="label"
                        id="labelValue"
                        clearable
                    ></v-text-field>
                    <v-text-field style="display:none"
                        v-model="nodeId"
                        id="idValue"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn @click="addNewLabelValue()" style="float: right;margin-top: 50px;">OK</v-btn>
                </div>
            </div>
         </div>

    </div>
</template>


<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import * as d3 from 'd3';
import axios from 'axios';

export default {
        name: 'TestTree',
        mounted() {
            let that = this;
            let $vueRouter = this.$router;
            let $vueStore = this.$store;

            console.log("mounted() getTreeData:", this.getTreeData);

            let treeData = this.getTreeData;

            // SMASS theme
            let nodeWidth = 300;
            let nodeHeight = 150;
            let nodeSpacingHorizontal = nodeWidth + 100;
            let nodeSpacingVertical = 20;
            let nodePadding = 15;

            let btnIconWidth = 20;
            let btnIconHeight = 20;

            let lineHeight = 16; // Text line height

            let colorNodeBgCollapsed = "rgba(120,160,190,1)";
            let colorNodeBgExpanded = "rgba(255,255,255,1)";

            // Calculate total nodes, max label length
            let totalNodes = 0;
            let maxLabelLength = 0;
            // panning variables
            let panSpeed = 200;
            // Misc. variables
            let i = 0;
            let duration = 750;
            let root;

            let margin = {top: 300, right: 20, bottom: 20, left: 20};

            // size of the diagram

            let viewerWidth =  document.getElementById('treeWrapper').clientWidth;
            let viewerHeight = document.getElementById('treeWrapper').clientHeight;
            console.log("width:" + viewerWidth + ' ' + "height: " + viewerHeight );
            /**
             * This function replaces d3.transform()
             */
            function getTransformation(transform) {
                // Create a dummy g for calculation purposes only. This will never
                // be appended to the DOM and will be discarded once this function
                // returns.
                let g = document.createElementNS("http://www.w3.org/2000/svg", "g");

                // Set the transform attribute to the provided string value.
                g.setAttributeNS(null, "transform", transform);

                // consolidate the SVGTransformList containing all transformations
                // to a single SVGTransform of type SVG_TRANSFORM_MATRIX and get
                // its SVGMatrix.
                let matrix = g.transform.baseVal.consolidate().matrix;

                // Below calculations are taken and adapted from the private function
                // transform/decompose.js of D3's module d3-interpolate.
                let {a, b, c, d, e, f} = matrix;   // ES6, if this doesn't work, use below assignment
                let scaleX, scaleY, skewX;

                scaleX = Math.sqrt(a * a + b * b)
                if (scaleX) {
                    a /= scaleX;
                    b /= scaleX;
                }

                skewX = a * c + b * d
                if (skewX) {
                    c -= a * skewX;
                    d -= b * skewX;
                }

                scaleY = Math.sqrt(c * c + d * d)
                if (scaleY) {
                    c /= scaleY;
                    d /= scaleY;
                    skewX /= scaleY;
                }

                if (a * d < b * c) {
                    a = -a;
                    b = -b;
                    skewX = -skewX;
                    scaleX = -scaleX;
                }

                return {
                    translateX: e,
                    translateY: f,
                    rotate: Math.atan2(b, a) * 180 / Math.PI,
                    skewX: Math.atan(skewX) * 180 / Math.PI,
                    scaleX: scaleX,
                    scaleY: scaleY
                };
            }

            let tree = d3.tree()
                .nodeSize([(nodeHeight+nodeSpacingVertical)]);

            let diagonal = d3.linkHorizontal();

            // A recursive helper function for performing some setup by walking through all nodes
            function visit(parent, visitFn, childrenFn) {
                if (!parent) return;

                visitFn(parent);

                let children = childrenFn(parent);
                if (children) {
                    let count = children.length;

                    for (let ii = 0; ii < count; ii++) {
                        visit(children[ii], visitFn, childrenFn);
                    }
                }
            }


            // Call visit function to establish maxLabelLength
            visit(treeData, function(d) {
                totalNodes++;
                maxLabelLength = Math.max(d.endpoint.length, maxLabelLength);

            }, function(d) {
                return d.children && d.children.length > 0 ? d.children : null;
            });


            // TOD: Pan function, can be better implemented.
            function pan(domNode, speedParam, direction) {

                console.log(speedParam);

                let speed = panSpeed;
                if (panTimer) {
                    clearTimeout(panTimer);
                    let translateCoords = getTransformation(svgGroup.attr("transform"));

                    // Maybe need to be global
                    let translateX;
                    let translateY;
                    let scale;

                    if (direction === 'left' || direction === 'right') {
                        translateX = direction === 'left' ? translateCoords.translate[0] + speed : translateCoords.translate[0] - speed;
                        translateY = translateCoords.translate[1];
                    } else if (direction === 'up' || direction === 'down') {
                        translateX = translateCoords.translate[0];
                        translateY = direction === 'up' ? translateCoords.translate[1] + speed : translateCoords.translate[1] - speed;
                    }

                    console.log("------------- zoomListener:", zoomListener);

                    scale = zoomListener.scale();
                    svgGroup.transition()
                        .attr("transform", "translate(" + translateX + "," + translateY + ") scale(" + scale + ")");
                    d3.select(domNode)
                        .select('g.node')
                        .attr("transform", "translate(" + translateX + "," + translateY + ")");
                    zoomListener.scale(zoomListener.scale());
                    zoomListener.translate([translateX, translateY]);
                    setTimeout(function() {
                        pan(domNode, speed, direction);
                    }, 50);
                }
            }

            // Define the zoom function for the zoomable tree
            function executeZoom() {
                let translateX = d3.event.transform.x;
                let translateY = d3.event.transform.y;
                let scale = d3.event.transform.k;
                svgGroup.attr("transform", "translate("+ translateX +", "+ translateY +") scale("+ scale +")");
            }


            // define the zoomListener which calls the zoom function on the "zoom" event constrained within the scaleExtents
            let zoomListener = d3.zoom().scaleExtent([0.1, 3]).on("zoom", executeZoom);

            // define the baseSvg, attaching a class for styling and the zoomListener
            let baseSvg = d3.select("#treeWrapper").append("svg")
                .attr("width", viewerWidth)
                .attr("height", viewerHeight)
                .call(zoomListener);

            // Function to center node when clicked/dropped so node doesn't get lost when collapsing/moving with large amount of children.
            function centerNode(source) {

                let scale = d3.zoomTransform(source);

                let x = -source.y0;
                let y = -source.x0;
                x = x * scale.k + viewerWidth / 2 - nodeWidth / 2;
                y = y * scale.k + viewerHeight / 2;

                let g = d3.select('g').transition()
                    .duration(duration)
                    .attr("transform", "translate(" + x + "," + y + ") scale(" + scale.k + ")");

                zoomListener.scaleTo(g, scale.k);
                zoomListener.translateTo(g, [x, y]);
            }

            function centerNodeVertically(source) {

                let scale = d3.zoomTransform(source);

                let x = source.y0;
                let y = -source.x0;
                x = x + nodeSpacingHorizontal;
                y = y * scale + viewerHeight / 2;
                d3.select('g').transition()
                    .duration(duration)
                    .attr("transform", "translate(" + x + "," + y + ")scale(" + scale + ")");
                zoomListener.scale(scale);
                zoomListener.translate([x, y]);
            }

            // Toggle children function
            function toggleChildren(d) {

                if (d.children !== null) {
                    console.log("...collapsing...");
                    // Collapse (hide children).
                    d._children = d.children;
                    d.children = null;
                } else if (d._children !== null) {
                    console.log("...expanding...");
                    // Expand (show children).
                    d.children = d._children;
                    d._children = null;
                }

                return d;
            }

            // Toggle children on click.
            function handleClickBtnToggleChildren(d) {
                d = toggleChildren(d);
                update();
                centerNode(d);
            }

            /**
             * Handle clicks on "SHOW NODE DETAILS" icons.
             * @param {Object} d - Node object (To read node data use d.data)
             * Needs implementation.
             */
            function handleClickBtnShowNodeDetails(d, evt) {

                let x = document.getElementById("box-content");
                let overlay = document.getElementById("overlay");

                        x.innerHTML = '<h3>node details</h3>' + ' ' +
                            '<div>' +
                             '<pre>' +

                                 '<b>'+'endpoint: '+ '</b>' + ''  +  JSON.stringify(d.data.endpoint, undefined, 2 ) + '<br>' +
                                 '<b>'+'nodeId: '+ '</b>' + ' '   + JSON.stringify(d.data.nodeId, undefined, 2 )  + '<br>' +
                                 '<b>'+'parentNodeId: '+ '</b>' + ' '  +  JSON.stringify(d.data.parentNodeId, undefined, 2 )  + '<br>' +
                                 '<b>'+'note: '+ '</b>' + ' '  + JSON.stringify(d.data.note, undefined, 2 )  + '<br>' +
                                 '<b>'+'request: '+ '</b>' + ' '  + JSON.stringify(d.data.request, undefined, 2)  + '<br />' +
                                 '<b>'+'response: '+ '</b>' + ' '  + JSON.stringify(d.data.response, undefined, 2 )  + '<br>'  +
                             '</pre>' +
                            '</div>'


                            x.innerHtml = '<vue-json-pretty>' + ' ' +  '</vue-json-pretty>'

                    overlay.style.display = "block";



                    const flyoutElement = this;
                    let targetElement = evt.target; // clicked element
                    console.log(flyoutElement );
                    console.log(targetElement);

            }



            // Go to another page to add a child.
            function funct1(response) {
                // ----- Populate stores with data from response, then go to CHOOSE MAIN SYMPTOM page. -----

                $vueStore.commit('ChooseMainSymptomStore/clearActiveChapter');
                $vueStore.commit('ChooseMainSymptomStore/clearSelectedMainSymptomCode');
                $vueStore.commit('ChooseMainSymptomStore/setChapterTree', response.data.data.CHAPTER_TREE);
                if (typeof response.data.data.START_QUESTIONS !== "undefined") {
                    $vueStore.commit('AssessmentStartStore/setStartQuestionsData', response.data.data.START_QUESTIONS);
                }
                if (typeof response.data.data.GENERAL_QUESTIONS !== "undefined") {
                    $vueStore.commit('AssessmentStartStore/setGeneralQuestionsData', response.data.data.GENERAL_QUESTIONS);

                    if (typeof response.data.data.GENERAL_QUESTIONS.countAnswered !== "undefined"
                        && typeof response.data.data.GENERAL_QUESTIONS.countTotal !== "undefined"
                        && response.data.data.GENERAL_QUESTIONS.countAnswered === response.data.data.GENERAL_QUESTIONS.countTotal) {
                        $vueStore.commit("AssessmentStartStore/enableFooterBtnNext");
                    }
                }
                $vueRouter.push('/main-symptom?referral=testsTreeNode');
            }

            function funct2(response) {
                // ----- Populate stores with data from response, then go to START ASSESSMENT page. -----

                $vueStore.commit("AssessmentStartStore/clearPatientProfileData");
                $vueStore.commit("AssessmentStartStore/clearGeneralQuestionsData");
                $vueStore.commit("AssessmentStartStore/disableFooterBtnNext");

                $vueStore.commit("AssessmentStartStore/clearStartQuestionsData");
                if (typeof response.data.data.START_QUESTIONS !== "undefined") {
                    $vueStore.commit('AssessmentStartStore/setStartQuestionsData', response.data.data.START_QUESTIONS);
                }
                if (typeof response.data.data.GENERAL_QUESTIONS !== "undefined") {
                    $vueStore.commit('AssessmentStartStore/setGeneralQuestionsData', response.data.data.GENERAL_QUESTIONS);

                    if (typeof response.data.data.GENERAL_QUESTIONS.countAnswered !== "undefined"
                        && typeof response.data.data.GENERAL_QUESTIONS.countTotal !== "undefined"
                        && response.data.data.GENERAL_QUESTIONS.countAnswered === response.data.data.GENERAL_QUESTIONS.countTotal) {
                        $vueStore.commit("AssessmentStartStore/enableFooterBtnNext");
                    }
                } else {
                    if (typeof response.data.data.START_QUESTIONS.countAnswered !== "undefined"
                        && typeof response.data.data.START_QUESTIONS.countTotal !== "undefined"
                        && response.data.data.START_QUESTIONS.countAnswered === response.data.data.START_QUESTIONS.countTotal) {
                        $vueStore.dispatch("AssessmentStartStore/loadGeneralQuestionList");
                    }
                }
                $vueRouter.push('/assessment-start?referral=testsTreeNode');
            }

            function funct3(response) {
                // ----- Populate stores with data from response, then go to SYMPTOMS QUESTIONS page. -----

                if (typeof response.data.data.RELATED_SYMPTOM_LIST.symptoms !== "undefined") {
                    $vueStore.commit("SymptomsQuestionsStore/setRelatedSymptomList", response.data.data.RELATED_SYMPTOM_LIST.symptoms);
                }
                if (typeof response.data.data.SYMPTOM_LIST !== "undefined" && typeof response.data.data.SYMPTOM_LIST.symptoms !== "undefined") {
                    $vueStore.commit("SymptomsQuestionsStore/setSelectedRelatedSymptomList", response.data.data.SYMPTOM_LIST.symptoms);
                }
                if (typeof response.data.data.SHARED_QUESTIONS !== "undefined") {
                    $vueStore.commit("SymptomsQuestionsStore/setSharedQuestionsData", response.data.data.SHARED_QUESTIONS);
                }
                if (typeof response.data.data.MAIN_SYMPTOM !== "undefined") {
                    $vueStore.commit("SymptomsQuestionsStore/setMainSymptom", response.data.data.MAIN_SYMPTOM);
                }

                if (typeof response.data.data.START_QUESTIONS !== "undefined") {
                    $vueStore.commit('AssessmentStartStore/setStartQuestionsData', response.data.data.START_QUESTIONS);
                }

                if (typeof response.data.data.GENERAL_QUESTIONS !== "undefined") {
                    $vueStore.commit('AssessmentStartStore/setGeneralQuestionsData', response.data.data.GENERAL_QUESTIONS);

                    if (typeof response.data.data.GENERAL_QUESTIONS.countAnswered !== "undefined"
                        && typeof response.data.data.GENERAL_QUESTIONS.countTotal !== "undefined"
                        && response.data.data.GENERAL_QUESTIONS.countAnswered === response.data.data.GENERAL_QUESTIONS.countTotal) {
                        $vueStore.commit("AssessmentStartStore/enableFooterBtnNext");
                    }
                }

                $vueStore.commit('ChooseMainSymptomStore/setSelectedMainSymptomCode', response.data.data.SYMPTOM_LIST.symptoms[0].code);
                $vueRouter.push('/symptoms-questions?referral=testsTreeNode');
            }

// Needs implementation.
            function handleClickBtnAddChild(d) {

                // Clear any old assessment data from stores.
                $vueStore.commit('ProductListStore/resetStore');
                $vueStore.commit('AssessmentStartStore/resetStore');
                $vueStore.commit('ChooseMainSymptomStore/resetStore');
                $vueStore.commit('SymptomsQuestionsStore/resetStore');
                $vueStore.commit('EvaluationStore/resetStore');
                $vueStore.commit('ScoringStore/resetStore');
                $vueStore.commit('SummaryStore/resetStore');
                $vueStore.commit('AssessmentAlertsStore/resetStore');

                let axiosRequest = axios.post(process.env.API_BASE_URL + '/test/createTestTreeBranch', {
                    nodeId: d.data.nodeId
                });
                axiosRequest.then((response) => {
                    if (typeof response.data.data !== "undefined" && typeof response.data.data.CHAPTER_TREE !== "undefined") {
                        funct1(response);
                    }
                    else if (typeof response.data.assessment !== "undefined" && typeof response.data.assessment.assessmentStatus !== "undefined") {
                        if (response.data.assessment.assessmentStatus === "START_QUESTIONS" || response.data.assessment.assessmentStatus === "GENERAL_QUESTIONS") {
                            funct2(response);
                        }
                        else if (response.data.assessment.assessmentStatus === "SYMPTOMS" || response.data.assessment.assessmentStatus === "SHARED_QUESTIONS") {
                            funct3(response);
                        }
                    }
                });
                axiosRequest.catch((error) => {
                    console.log(error);
                });
            }

            function handleClickShowPopUp (d) {
                console.log("popup with 2 columns will be in action");
                let x = document.getElementById("box-content-one");
                let y = document.getElementById("box-content-two");
                let overlay = document.getElementById("overlayColumns");

                x.innerHTML =
                    '<div>' +
                    '<pre>' +
                    '<b>'+'endpoint: '+ '</b>' + ''  +  JSON.stringify(d.data.endpoint, undefined, 2 ) + '<br>' +
                    '<b>'+'nodeId: '+ '</b>' + ' '   + JSON.stringify(d.data.nodeId, undefined, 2 )  + '<br>' +
                    '<b>'+'parentNodeId: '+ '</b>' + ' '  +  JSON.stringify(d.data.parentNodeId, undefined, 2 )  + '<br>' +
                    '<b>'+'note: '+ '</b>' + ' '  + JSON.stringify(d.data.note, undefined, 2 )  + '<br>' +
                    '</pre>' +
                    '</div>'

                y.innerHTML =
                    '<div>' +
                    '<pre>' +
                    '<b>'+'request: '+ '</b>' + ' '  + JSON.stringify(d.data.request, undefined, 2)  + '<br />' +
                    '<b>'+'response: '+ '</b>' + ' '  + JSON.stringify(d.data.response, undefined, 2 )  + '<br>'  +
                    '</pre>' +
                    '</div>'


                x.innerHtml = '<vue-json-pretty>' + ' ' +  '</vue-json-pretty>';
                y.innerHtml = '<vue-json-pretty>' + ' ' +  '</vue-json-pretty>'

                overlay.style.display = "block";
            }



            function deleteNodeTree(d) {

                console.log('delete node');

                console.log("deleteNode(). d:", d);

                let axiosRequest = axios.post(process.env.API_BASE_URL + '/test/deleteTestTreeNode', {
                    nodeId: d.data.nodeId
                });
                axiosRequest.then((response) => {
                    $vueStore.commit("TestStore/setTreeData", response.data.treeRoot[0]);

                    treeData = response.data.treeRoot[0];

                    root = d3.hierarchy(treeData, function(d) { return d.children; });
                    root.x0 = viewerHeight / 2;
                    root.y0 = 0;

                    update();
                });
                axiosRequest.catch((error) => {
                    console.log(error);
                });

            }

            function handleClickEditLabel(d) {
                console.log("edit label");
                d3.select(this).classed('active', true);
                let parentIcon = d3.select(this.parentNode);
                let updateText = parentIcon._groups[0][0].textContent;
                let overlay = document.getElementById("overlayLabel");

                if (that.label !== ''){
                    that.label = updateText;
                }
                else {
                    that.label = d.data.label;
                }

                that.nodeId = d.data.nodeId

                overlay.style.display = "block";

            }

            // =============== Text helpers ===============

            function measureTextWidth(text) {
                let context = document.createElement("canvas").getContext("2d");
                return context.measureText(text).width;
            }


            function splitLongText(text) {
                let targetWidth = (Math.sqrt(measureTextWidth(text.trim()) * lineHeight) * 2) - btnIconWidth - nodePadding*2;
                let words = text.split(/\s+/g); // To hyphenate: /\s+|(?<=-)/
                let lines = [];
                let line = {};
                let lineWidth0 = Infinity;

                for (let ii = 0, n = words.length; ii < n; ++ii) {
                    let lineText1 = (line ? line.text + " " : "") + words[ii];
                    let lineWidth1 = measureTextWidth(lineText1);

                    if ((lineWidth0 + lineWidth1) / 2 < targetWidth) {
                        line.width = lineWidth0 = lineWidth1;
                        line.text = lineText1;

                        lines[lines.length-1] = line.text;
                    }
                    else {
                        lineWidth0 = measureTextWidth(words[ii]);
                        line = {width: lineWidth0, text: words[ii]};
                        lines.push(line.text);
                    }
                }

                return lines;
            }

            function functA1(d, allTextLines) {
                if (typeof d.data.request.productId !== "undefined") {
                    allTextLines = allTextLines.concat(splitLongText("productId: " + d.data.request.productId));
                }
                if (typeof d.data.request.questionName !== "undefined") {
                    allTextLines = allTextLines.concat(splitLongText("questionName: " + d.data.request.questionName));
                }
                if (typeof d.data.request.answerText !== "undefined") {
                    allTextLines = allTextLines.concat(splitLongText("answerText: " + d.data.request.answerText));
                }
                if (typeof d.data.request.firstName !== "undefined") {
                    allTextLines = allTextLines.concat(splitLongText("firstName: " + d.data.request.firstName));
                }
                if (typeof d.data.request.name !== "undefined") {
                    allTextLines = allTextLines.concat(splitLongText("name: " + d.data.request.name));
                }
                if (typeof d.data.request.phone !== "undefined") {
                    allTextLines = allTextLines.concat(splitLongText("phone: " + d.data.request.phone));
                }
                if (typeof d.data.request.email !== "undefined") {
                    allTextLines = allTextLines.concat(splitLongText("email: " + d.data.request.email));
                }
                if (typeof d.data.request.comment !== "undefined") {
                    allTextLines = allTextLines.concat(splitLongText("comment: " + d.data.request.comment));
                }
                if (typeof d.data.request.searchText !== "undefined") {
                    allTextLines = allTextLines.concat(splitLongText("searchText: " + d.data.request.searchText));
                }
                if (typeof d.data.request.symptomName !== "undefined") {
                    allTextLines = allTextLines.concat(splitLongText("symptomName: " + d.data.request.symptomName));
                }
                return allTextLines;
            }

            function prepareAllNodeTextLines(d) {
                let allTextLines = [];

                if (typeof d.data.label !== "undefined" && d.data.label !== null) {
                    console.log("data label")
                    allTextLines = allTextLines.concat( splitLongText( d.data.label));

                } else {
                    allTextLines = allTextLines.concat(splitLongText(d.data.endpoint));

                    if (typeof d.data.request !== "undefined" && d.data.request !== null) {
                        allTextLines = functA1(d, allTextLines);
                    }
                }



                return allTextLines;
            }

            function computeTextRadius(lines) {
                let radius = 0;
                for (let ii = 0, n = lines.length; ii < n; ++ii) {
                    let dy = (Math.abs(ii - n / 2 + 0.5) + 0.5) * lineHeight;
                    let dx = measureTextWidth(lines[ii]) / 2;
                    radius = Math.max(radius, Math.sqrt(dx ** 2 + dy ** 2));
                }
                return radius;
            }


            // =============== Update nodes ===============

            function update() {
                // Compute the new height, function counts total children of root node and sets tree height accordingly.
                // This prevents the layout looking squashed when new nodes are made visible or looking sparse when nodes are removed
                // This makes the layout more consistent.

                tree = tree.nodeSize([(nodeHeight+nodeSpacingVertical), nodeSpacingHorizontal]);





                // Compute the new tree layout.

                // Assigns the x and y position for the nodes
                let treeData = tree(root);

                // Compute the new tree layout.
                let nodes = treeData.descendants();
                let links = treeData.descendants().slice(1);

                // Update the nodes…
                let node = svgGroup.selectAll("g.node")
                    .data(nodes, function(d) {
                        return d.nodeId || (d.nodeId = ++i);
                    });

                // Enter any new nodes at the parent's previous position.
                let nodeEnter = node.enter().append("g")
                    .attr("class", "node")
                    .attr("transform", function(d) {
                        return "translate(" + d.y + "," + d.x + ")";
                    });

                function showTreeNodes() {

                    nodeEnter.append('rect')
                        .attr('class', 'nodePanel')
                        .attr('width', nodeWidth)
                        .attr('height', nodeHeight)
                        .attr('rx', 6)
                        .attr('ry', 6)
                        .attr('y', -(nodeHeight / 2))
                        .style('stroke-width', '1px')
                        .style('stroke', 'rgb(180, 180, 180)')
                        .style('fill', function(d) {
                            return d._children ? colorNodeBgCollapsed : colorNodeBgExpanded;
                        });

                    let nodeText = nodeEnter.append("text")
                        .attr("x", function() {
                            return 0;
                        })
                        .attr("y", 0)
                        .attr('class', 'nodeText')
                        .attr("text-anchor", function() {
                            return "start";
                        })


                    // =============== Display texts ===============

                    nodeText.each(function(d) {
                        let allNodeLines = prepareAllNodeTextLines(d);
                        let textRadius = computeTextRadius(allNodeLines);

                        let crtNodeText = d3.select(this);

                        let availableSpace = Math.min((nodeWidth - btnIconWidth - nodePadding*2), (nodeHeight - nodePadding*2)) / 2;

                        crtNodeText
                            .attr("transform", "translate(0, 0) scale("+ (availableSpace / textRadius)*1.5 +")")
                            .selectAll("tspan")
                            .data( allNodeLines )
                            .enter().append("tspan")
                            .attr("x", nodePadding)
                            .attr("y", (d, i) => {
                                return (i - allNodeLines.length / 2 + 0.8) * lineHeight;
                            })
                            .text((d) => {
                                return d;
                            });
                    });


                    // =============== BUTTONS ===============

                    // Create button to toggle children.

                    nodeEnter.append("image").attr("xlink:href", "static/img/icon-expand.svg")
                        .attr('class', 'tree-node-btn btnToggleChildren')
                        .attr('width', btnIconWidth)
                        .attr('height', btnIconHeight)
                        .attr('x', nodeWidth-nodePadding-btnIconWidth)
                        .attr('y', -35)
                        .on('click', handleClickBtnToggleChildren);


                    // Create button to show details.
                    nodeEnter.append("image").attr("xlink:href", "static/img/icon-details.svg")
                        .attr('class', 'tree-node-btn btnShowNodeDetails')
                        .attr('width', btnIconWidth)
                        .attr('height', btnIconHeight)
                        .attr('x', nodeWidth-nodePadding-btnIconWidth)
                        .attr('y', -10)
                        .on('click', handleClickBtnShowNodeDetails);

                    // Create button to add child.

                        nodeEnter.append("image").attr("xlink:href", "static/img/icon-add-child.svg")
                            .attr('class', 'tree-node-btn btnAddChild')
                            .attr('width', btnIconWidth)
                            .attr('height', btnIconHeight)
                            .attr('x', nodeWidth - nodePadding - btnIconWidth)
                            .attr('y', 15)
                            .on('click', handleClickBtnAddChild);

                        nodeEnter.append("image").attr("xlink:href", "static/img/icon-add-child.svg")
                            .attr('class', 'tree-node-btn btnAddChild')
                            .attr('width', btnIconWidth)
                            .attr('height', btnIconHeight)
                            .attr('x', nodeWidth - nodePadding - btnIconWidth)
                            .attr('y', 15)
                            .on('click', handleClickShowPopUp);


                    nodeEnter.append("image").attr("xlink:href", "static/img/edit_icon.svg")
                        .attr('class', 'tree-node-btn btnEditLabel')
                        .attr('width', btnIconWidth)
                        .attr('height', btnIconHeight)
                        .attr('x', nodeWidth-nodePadding-btnIconWidth)
                        .attr('y', -35)
                        .on('click', handleClickEditLabel);

                    /** delete node icon***/
                    nodeEnter.append("image").attr("xlink:href", "static/img/delete.svg")
                        .attr('class', function(d) {
                            // Show delete button only on child nodes that have brothers.
                            if (d.parent === null || (d.parent.children.length <= 1)) {
                                return 'tree-node-btn btnAddChild hidden';
                            }
                            else {
                                return 'tree-node-btn btnAddChild';
                            }
                        })
                        .attr('width', btnIconWidth)
                        .attr('height', btnIconHeight)
                        .attr('x', nodeWidth - nodePadding - btnIconWidth)
                        .attr('y', 40)
                        .on('click', deleteNodeTree);

                      nodeEnter._groups[0].forEach(function(node) {

                        let nodeDetails = node.childNodes[1].childNodes[0].innerHTML;

                          if(nodeDetails.includes('/assessment/')) {
                              node.childNodes[6].remove();
                          }

                        if (nodeDetails === "/assessment/scoring" || nodeDetails === "/assessment/evaluation" || nodeDetails === "/assessment/evaluateAssessment") {
                            node.childNodes[4].remove();
                            node.childNodes[4].remove();
                        }

                        else if(nodeDetails !== "/assessment/scoring"){
                            node.childNodes[5].remove();
                        }

                          /**** remove buttons from nodes with label *****/
                          if(nodeDetails.includes('/assessment/')) {

                          } else {
                              node.classList.add("labelnode");
                              node.childNodes[2].remove();
                              node.childNodes[2].remove();
                              node.childNodes[2].remove();
                              node.childNodes[3].classList.remove('hidden');
                          }

                    })

                }

                showTreeNodes();


                // =============== ... ===============



                // Change the circle fill depending on whether it has children and is collapsed
                node.select(".nodePanel")
                    .style("fill", function(d) {
                        return d._children ? colorNodeBgCollapsed : colorNodeBgExpanded;
                    });

                // Transition nodes to their new position.
                let nodeUpdate = node.transition()
                    .duration(duration)
                    .attr("transform", function(d) {
                        return "translate(" + d.y + "," + d.x + ")";
                    });

                // Fade the text in
                nodeUpdate.select("text")
                    .style("fill-opacity", 1);

                // Transition exiting nodes to the parent's new position.
                let nodeExit = node.exit()
                    .transition()
                        .duration(duration)
                        .attr("transform", function(d) {
                            return "translate(" + d.y + "," + d.x + ")";
                        })
                        .remove();

                nodeExit.select("circle")
                    .attr("r", 0);

                nodeExit.select("text")
                    .style("fill-opacity", 0);

                // Update the links…
                let link = svgGroup.selectAll("path.link")
                    .data(links, function(d) {
                        return d.nodeId;
                    });

                // Enter any new links at the parent's previous position.
                link.enter().insert("path", "g")
                    .attr("class", "link")
                    .attr("d", function(d) {
                        return diagonal({
                            source: [d.parent.y, d.parent.x],
                            target: [d.y, d.x]
                        });
                    });

                // Transition links to their new position.
                link.transition()
                    .duration(duration)
                    .attr("d", function(d) {
                        return diagonal({
                            source: [d.parent.y, d.parent.x],
                            target: [d.y, d.x]
                        });
                    });

                // Transition exiting nodes to the parent's new position.
                link.exit().transition()
                    .duration(duration)
                    .attr("d", function(d) {
                        return diagonal({
                            source: [d.parent.y, d.parent.x],
                            target: [d.y, d.x]
                        });
                    })
                    .remove();

                // Stash the old positions for transition.
                nodes.forEach(function(d) {
                    d.x0 = d.x;
                    d.y0 = d.y;
                });
            }

            // Append a group which holds all nodes and which the zoom Listener can act upon.
            let svgGroup = baseSvg.append("g")
                .attr("class", "tree-content-wrapper")
                .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

            // Define the root
            root = d3.hierarchy(treeData, function(d) { return d.children; });
            root.x0 = viewerHeight / 2;
            root.y0 = 0;

            // Layout the tree initially and center on the root node.
            update();
            centerNodeVertically(root);

        },
        data () {
            return {
                label: '',
                nodeId: ''
            }
        },
        computed: {
            ...mapGetters({
                getTreeData: 'TestStore/getTreeData',
                getEditLabel: 'TestStore/getEditLabel'

            }),

        },

        methods: {

            hideNodePopup: function () {
                document.getElementById("overlay").style.display = "none";
            },
            hideNodePopupColumns: function () {
                document.getElementById("overlayColumns").style.display = "none";
            },
            hideEditLabelPopup: function () {
                document.getElementById("overlayLabel").style.display = "none";

                setTimeout(function(){
                    let iconEdit = Array.from(document.getElementsByClassName("active"))
                    if(iconEdit.length){
                        iconEdit[0].classList.remove('active');
                    }
                }, 10)
            },
            escapeKeyListener: function (evt) {
                if (evt.keyCode === 27) {
                    this.hideNodePopup();
                    this.hideNodePopupColumns();
                    this.hideEditLabelPopup();
                }
            },
            addNewLabelValue: function () {
                console.log(this);
                let axiosRequest = axios.post(process.env.API_BASE_URL + '/test/updateNodeLabel', {
                    nodeId: this.nodeId,
                    label: this.label
                });

                let that = this;
                axiosRequest.then(() => {
                    this.$store.commit('TestStore/setEditLabel', this.label);

                    let editIcon =  Array.from(document.getElementsByClassName("active"));

                    editIcon.forEach(function(entry) {
                        let tspanValue =  Array.from(entry.previousSibling.getElementsByTagName('tspan'));

                        for (let ii = 1; ii < tspanValue.length; ii++) {
                            tspanValue[ii].innerHTML = ''
                        }

                        tspanValue[0].innerHTML =  that.getEditLabel
                        tspanValue[0].classList.add("forlabel");
                        tspanValue[0].setAttribute('x', 5);
                        tspanValue[0].setAttribute('y', 2);
                    });

                    setTimeout(function(){
                        if(editIcon.length){
                            editIcon[0].classList.remove('active');
                        }
                    }, 10)

                    this.hideEditLabelPopup();

                });
                axiosRequest.catch((error) => {
                    console.log(error);
                });
            }
        },
        created: function() {
            document.addEventListener('keyup', this.escapeKeyListener);
        },
        destroyed: function() {
            document.removeEventListener('keyup', this.escapeKeyListener);
        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss">



    .question-item {
        height: 100%;

        #treeWrapper {
            height:100%;
            width:100%;
        }

        .tree-node-btn {
            cursor: pointer;
        }

        .node text {
            font-size:13px;
            font-family:sans-serif;
        }

        .link {
            fill: none;
            stroke: #1a2227;
            stroke-width: 1px;
        }

        //***** POPUP STYLE ****** //
        .modal-box {
            position: absolute;
            left: 10%;
            right:10%;
            top: 10%;
            bottom:10%;
            min-width: 50%;
            min-height: 40%;
            z-index: 5;
            background-color: white;

            span {
                padding:20px;

                .icon {
                    font-weight: $font-weight-light;
                    font-size: $font-size-big;

                    &:hover{
                        cursor: pointer;
                    }
                }
            }

            pre {
                background-color: white !important;
                color: $color-body-text;
                box-shadow: none !important;
                border: none !important;
                padding: 20px;
                height: 100%;
                overflow-y: scroll;
            }
        }

        #box-content, #box-content-one, #box-content-two {

            height: 100%;

            h3 {
                padding: 20px;
                background-color: $color-brand-primary;
                font-weight: $font-weight-light;
                font-size: $font-size-big;
            }

            div{
                height: 90%;
            }
        }
        #overlay, #overlayColumns, #overlayLabel {
            position: fixed;
            display: none;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0,0,0,0.5);
            z-index: 5;
        }

        .close-node-details {
            bottom: 20px;
            right: 20px;
        }
    }

     #box-content-label {

         label {
            padding: 10px 60px;
         }

         .input-group__input {
             height: 60px !important;
             padding: 10px 30px;
             box-shadow: 2px 2px 2px 2px gainsboro;

         }

         height: 100%;

         h3 {
             padding: 20px;
             background-color: $color-brand-primary;
             font-weight: $font-weight-light;
             font-size: $font-size-big;
         }
     }


    .close-edit-label {
        background-color: $color-brand-primary;
        height: 80px;
        padding: 20px 40px;

        span {
            font-size: $font-size-big;
            padding: 0 !important;
        }
    }

    .question-item #boxLabel.modal-box {
        max-width: 30%;
        max-height: 30%;
        left: 25%;
        top: 20%;
        margin-top: 40px;
        margin-left: 40px;

        .input-group {
            margin-top: 50px;
            width: 70%;
            margin-left: 40px;
        }

        button {
            position: absolute;
            right: 25%;
            margin-top: 30px;
        }
    }

    .forlabel {
        font-size: 6px;
    }

</style>



// WEBPACK FOOTER //
// src/professional/components/tests/TestTree.vue